import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ColorGray500 } from "@nxt-costco-com/forge-design-tokens";
const BaseCarousel = styled(Box)(() => {
  return {
    overflow: "hidden",
    position: "relative",
    width: "100%"
  };
});
const CarouselContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "slideGap"
})(({ slideGap }) => ({
  flex: "0 0 100%",
  alignItems: "stretch",
  backfaceVisibility: "hidden",
  display: "flex",
  marginLeft: `-${slideGap}`,
  touchAction: "pan-y"
}));
const CarouselSlide = styled(Box, {
  shouldForwardProp: (prop) => prop !== "slideGap" && prop !== "peekAdjacent" && prop !== "itemsPerSlide"
})(
  ({
    slideGap,
    peekAdjacent,
    itemsPerSlide
  }) => ({
    "& > *": {
      objectFit: "cover",
      width: "100%"
    },
    flex: `0 0 ${peekAdjacent ? `calc(${100 / itemsPerSlide}% - ${peekAdjacent})` : `${100 / itemsPerSlide}%`}`,
    minWidth: 0,
    position: "relative",
    padding: "2px",
    paddingLeft: slideGap
  })
);
const scrollbarStyles = {
  display: "flex",
  alignItems: "center",
  height: "11px",
  borderTop: `1px solid ${ColorGray500}`,
  borderBottom: `1px solid ${ColorGray500}`,
  background: `#FAFAFA`,
  padding: "2px 246px 2px 3px",
  cursor: "pointer",
  marginTop: "8px",
  position: "relative"
};
const scrollbarInnerStyles = {
  position: "absolute",
  height: "7px",
  background: ColorGray500,
  borderRadius: "4px",
  transition: "background 0.3s"
};
export {
  BaseCarousel,
  CarouselContainer,
  CarouselSlide,
  scrollbarInnerStyles,
  scrollbarStyles
};
